import type { FC } from 'react'
import appConfig from '#/src/appConfig'
import { FooterStandard, type FooterStandardProps } from 'storefront-modules/layout/footer'
import { FooterLogo } from '#/src/custom/layout/FooterLogo'

type IFooter = Pick<FooterStandardProps, 'footerItems' | 'socialMediaItems'>

const CustomFooter: FC<IFooter> = ({ footerItems, socialMediaItems }) => {
  return (
    <FooterStandard
      logo={<FooterLogo />}
      footerItems={footerItems}
      socialMediaItems={socialMediaItems}
      paymentProviderName={appConfig.paymentProviderConfig?.providerName}
      maxColumns={appConfig.footerConfig?.maxColumns}
    />
  )
}

export default CustomFooter
